import OverviewComponent from "../components/overview.component"

const Overview = (props) => {
    return <OverviewComponent type={props.type}></OverviewComponent>;
  };
  
  export default Overview;